/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_Task_3Inputs */

const en_mk_tb_example_task_3 = /** @type {(inputs: Mk_Tb_Example_Task_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agree on the first milestone`)
};

const id_mk_tb_example_task_3 = /** @type {(inputs: Mk_Tb_Example_Task_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepakati milestone pertama`)
};

/**
* | output |
* | --- |
* | "Agree on the first milestone" |
*
* @param {Mk_Tb_Example_Task_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_task_3 = /** @type {((inputs?: Mk_Tb_Example_Task_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_Task_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_task_3(inputs)
	return en_mk_tb_example_task_3(inputs)
});